module.exports = __webpack_public_path__ + "img/lens-150-minus-06.4570bdd8.png";